export default defineNuxtPlugin({
  name: 'session-fetch-plugin',
  enforce: 'pre',
  async setup() {
    const { $locale } = useNuxtApp();

    if ($locale.value === 'zh-cn') {
      return;
    }

    await useOidcAuth().fetch();
  }
});
